export default "__VITE_ASSET__BrKZ$L1i__"